import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AuthHttp } from '../../../services/http/http.service';
import { asError, requestWithFallback, requestWithMappedResponse, requestWithResponse } from '../../../services/http/request-with-response';

@Injectable({ providedIn: 'root' })
export class SucursalService {
  private readonly SELECTED_ITEM_KEY = 'SELECTED_SUCURSAL';
  public existeTienda = false;

  constructor(private readonly http: HttpClient, private readonly authHttp: AuthHttp) {}

  setCurrent(sucursal) {
    localStorage.setItem(this.SELECTED_ITEM_KEY, JSON.stringify(sucursal));
  }

  getCurrent() {
    return JSON.parse(localStorage.getItem(this.SELECTED_ITEM_KEY));
  }

  set(grupo_id, empresa_id, sucursal_id, sucursal) {
    const key = SucursalService.name + '' + grupo_id + '' + empresa_id + '' + sucursal_id;
    localStorage.setItem(key, JSON.stringify(sucursal));
  }

  get(grupo_id, empresa_id, sucursal_id) {
    const key = SucursalService.name + '' + grupo_id + '' + empresa_id + '' + sucursal_id;
    return JSON.parse(localStorage.getItem(key));
  }
  getTienda(empresa_id, sucursal_id) {
    return requestWithFallback(this.authHttp.get(`${environment.apiURLs.private}/empresa/${empresa_id}/altas/tienda/get/${sucursal_id}`, {}), []);
  }
  getPaises(empresa_id) {
    return requestWithFallback(this.authHttp.get(`${environment.apiURLs.private}/empresa/altas/tienda/paises`, {}), []);
  }

  getProvincias(empresa_id, pais) {
    return requestWithFallback(this.authHttp.get(`${environment.apiURLs.private}/empresa/${empresa_id}/altas/tienda/pais/${pais}/provincias`, {}), []);
  }

  existeTiendaPF(cdgEmpresa: number, cdgTienda: number, cdgAbreviadoTienda: string = '') {
    return requestWithMappedResponse(
      this.authHttp.get(`${environment.apiURLs.private}/empresa/${cdgEmpresa}/tienda/${cdgTienda}/existe`, {}),
      (objects: any) => objects['datos'] !== undefined ? objects['datos']['exist'] : false,
      () => new Error('No se pudo comprobar la tienda')
    ).catch(() => []);
  }
  upload(parameters, empresa_id, grupo_id: string) {
    return requestWithResponse(
      this.http.post(`${environment.apiURLs.private}/grupo/${grupo_id}/empresa/${empresa_id}/altas/tienda/actualizar`, { parameters }),
      () => undefined,
      asError
    );
  }
  getSubAlmacenes(empresa_id) {
    return requestWithFallback(this.authHttp.get(`${environment.apiURLs.private}/empresa/${empresa_id}/altas/tienda/subalmacen/listar`, {}), []);
  }
}
